/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { Text, theme } from "@nordcloud/gnui";

type ExtendedSidebarProps = {
  children: React.ReactNode;
  title?: string;
  isOpen: boolean;
};

type Props = {
  isOpen: boolean;
};

const Wrap = styled.div<Props>`
  position: fixed;
  display: block;
  width: 30rem;
  height: 100vh;
  top: 0;
  right: 30rem;
  bottom: 0;
  overflow: auto;
  background: ${theme.color.background.ui01};
  border: 1px solid ${theme.color.border.border01};
  will-change: transform;
  transition: ${theme.transition};
  z-index: ${theme.zindex.deep};
  transform: ${({ isOpen }) =>
    isOpen ? "translate3d(0,0,0)" : `translate3d(100%,0,0)`};
`;

const Content = styled.div`
  flex: 1;
  padding: ${theme.spacing.spacing02} ${theme.spacing.spacing04}
    ${theme.spacing.spacing01};
  margin-bottom: 0;
`;

const Inner = styled.div<Props>`
  will-change: transform;
  transition: ${theme.transition};
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
`;

const Header = styled.div`
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  width: 100%;
  z-index: ${theme.zindex.default};
  flex-wrap: nowrap;
  align-items: center;
  background-color: ${theme.color.background.ui01};
  line-height: ${theme.lineHeight};
  padding: ${theme.spacing.spacing04};
  margin: 0 auto;
  box-sizing: border-box;
  box-shadow: ${theme.shadow.shadow02};
`;

function ExtendedSidebar({ children, title, isOpen }: ExtendedSidebarProps) {
  return (
    <Wrap isOpen={isOpen}>
      <Inner isOpen={isOpen}>
        <Header>
          <Text weight="medium" tag="span" size="md">
            {title}
          </Text>
        </Header>
        <Content>{children}</Content>
      </Inner>
    </Wrap>
  );
}

export { ExtendedSidebar };
